import { FormControl, InputLabel, MenuItem, Select, type BaseSelectProps } from "@mui/material";
import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { type CustomRepeatType } from "../hooks/use-number-of-repeats";

type CustomRepeatPeriodProps = Omit<BaseSelectProps, "onChange" | "value"> & {
  value: CustomRepeatType["period"];
  onChange: (value: CustomRepeatType["period"]) => void;
};

export const CustomRepeatPeriod: FC<CustomRepeatPeriodProps> = ({
  value,
  onChange,
  label,
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <FormControl sx={{ width: 120 }}>
      <InputLabel id="period-label">{label}</InputLabel>
      <Select
        labelId="period-label"
        label={label}
        value={value}
        onChange={(e) => {
          const val = e.target.value as CustomRepeatType["period"];
          onChange(val);
        }}
        {...props}
      >
        <MenuItem value="day" data-analytics-id="create-event-form-custom-repeat-period-day">
          {t("Days")}
        </MenuItem>
        <MenuItem value="week" data-analytics-id="create-event-form-custom-repeat-period-week">
          {t("Weeks")}
        </MenuItem>
        <MenuItem value="month" data-analytics-id="create-event-form-custom-repeat-period-month">
          {t("Months")}
        </MenuItem>
        <MenuItem value="year" data-analytics-id="create-event-form-custom-repeat-period-year">
          {t("Years")}
        </MenuItem>
      </Select>
    </FormControl>
  );
};
